import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @OmerKosar
 */

const ReconciledOrders = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, show: false },
			{ Header: 'codReportID', accessor: 'codReportID', filterType: FilterType.number, width: 70 },
			{ Header: 'payableCODReportID', accessor: 'payableCODReportID', filterType: FilterType.number, width: 70 },
			{
				Header: 'orderID',
				accessor: 'orderId',
				filterType: FilterType.string,
				width: 70,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'otoOrderID',
				filterType: FilterType.number,
				width: 50,
				showCopyButton: true
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.TRACKING_URL,
				show: false
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompName',
				filterType: FilterType.multiSelection,
				width: 100
			},
			{
				Header: 'deliveryDate',
				accessor: 'deliveryDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'amountReceived',
				accessor: 'amountReceived',
				filterType: FilterType.float,
				width: 80,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'amountAtOTO',
				accessor: 'amount',
				filterType: FilterType.float,
				width: 80,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'receiveStatus',
				accessor: 'receiveStatus',
				filterType: FilterType.string,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			},
			{
				Header: 'payableStatus',
				accessor: 'payableStatus',
				filterType: FilterType.string,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.RECONCILED_ORDERS}
				columns={columns}
				fetchUrl={FINANCE.GET_RECONCILED_ORDERS_LIST}
				exportName="reconciledOrders"
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default ReconciledOrders;
